import { slice } from './slice';

const { reducer } = slice;

export default reducer;
